// Centralized API base resolution
// Priority:
// 1) REACT_APP_API_BASE if provided
// 2) window.__API_BASE__ (runtime override, optional)
// 3) window.location.origin (same origin)
// The value is normalized (no trailing slash).

export function getApiBase() {
  const envBase = (process.env.REACT_APP_API_BASE || 'https://testapi.cs2servers.com').trim();
  const runtimeBase = typeof window !== 'undefined' && window.__API_BASE__ ? String(window.__API_BASE__) : '';
  const fallback = typeof window !== 'undefined' && window.location ? window.location.origin : '';
  const base = (envBase || runtimeBase || fallback || '').replace(/\/+$/, '');
  return base;
}

export const API_BASE = getApiBase();

export function warnIfInsecureMismatch() {
  try {
    if (typeof window === 'undefined') return;
    const pageHttps = window.location && window.location.protocol === 'https:';
    const apiUrl = new URL(API_BASE, window.location.href);
    if (pageHttps && apiUrl.protocol !== 'https:') {
      // eslint-disable-next-line no-console
      console.warn('[config] Page is https but API_BASE is not https:', API_BASE);
    }
  } catch (_) {}
}
